import { render, staticRenderFns } from "./SlotChip.vue?vue&type=template&id=0f143a9a&scoped=true"
import script from "./SlotChip.vue?vue&type=script&lang=js"
export * from "./SlotChip.vue?vue&type=script&lang=js"
import style0 from "./SlotChip.vue?vue&type=style&index=0&id=0f143a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f143a9a",
  null
  
)

export default component.exports